function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from "react";
import { trackFAQSearch } from "../../../../../js/feature/gtm-tracking";
import SearchHeader from "./search-header";
import SearchField from "./search-field";
import SearchFieldSuggestions from "./search-field-suggestions";
import SearchPopularQueries from "./search-popular-queries";
import SearchListNavigation from "./search-list-navigation";
import SearchScrollToTop from "./search-scroll-top-btn";
var Search = /*#__PURE__*/function (_React$Component) {
  function Search(props) {
    var _this;
    _classCallCheck(this, Search);
    _this = _callSuper(this, Search, [props]);
    _this.state = {
      searchQuery: "",
      allFilters: [],
      pageScrollOffset: window.pageYOffset,
      showSuggestions: false
    };
    _this.searchContainer = /*#__PURE__*/React.createRef();
    _this.searchInput = /*#__PURE__*/React.createRef();
    _this.updateSearchQuery = _this.updateSearchQuery.bind(_this);
    _this.search = _this.search.bind(_this);
    _this.scrollToTop = _this.scrollToTop.bind(_this);
    _this.updateScrollState = _this.updateScrollState.bind(_this);
    return _this;
  }
  _inherits(Search, _React$Component);
  return _createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("scroll", this.updateScrollState);
      this.getAllFilters();
      this.getSearchQueryFromFilters();
    }
  }, {
    key: "getAllFilters",
    value: function getAllFilters() {
      var allFilters = this.props.filters.map(function (filter) {
        return filter.elements;
      }).flatten();
      this.setState({
        allFilters: allFilters
      });
    }
  }, {
    key: "getSearchQueryFromFilters",
    value: function getSearchQueryFromFilters() {
      var selectedFilterElements = this.props.filters.map(function (filter) {
        return filter.elements;
      }).flatten().filter(function (element) {
        return element.selected === true;
      }).map(function (filter) {
        return filter.name;
      });
      if (selectedFilterElements.length) {
        var searchQuery = selectedFilterElements.join(", ");
        this.setState({
          searchQuery: searchQuery
        });
        trackFAQSearch(searchQuery, "url_search_params");
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("scroll", this.updateScrollState);
    }
  }, {
    key: "updateScrollState",
    value: function updateScrollState() {
      this.setState({
        pageScrollOffset: window.pageYOffset
      });
    }
  }, {
    key: "updateSearchQuery",
    value: function updateSearchQuery(searchQuery) {
      this.setState({
        searchQuery: searchQuery,
        showSuggestions: searchQuery.length > 0
      });
    }
  }, {
    key: "search",
    value: function search(query, updateSearchQuery, initatedBy) {
      this.props.onClearAll();
      if (updateSearchQuery) {
        this.setState({
          searchQuery: query,
          showSuggestions: false
        });
      } else {
        this.setState({
          showSuggestions: false
        });
      }
      this.searchItems(query);
      this.scrollToTop();
      trackFAQSearch(query, initatedBy);
    }
  }, {
    key: "searchItems",
    value: function searchItems(query) {
      var _this2 = this;
      var itemsContainingQuery = this.props.rawContentTypes.filter(function (contentType) {
        var filteredContentType = contentType.items.filter(function (item) {
          var itemFiltersNames = item.filters.map(function (filter) {
            var _this2$state$allFilte;
            return (_this2$state$allFilte = _this2.state.allFilters.find(function (item) {
              return item.id === filter;
            })) === null || _this2$state$allFilte === void 0 ? void 0 : _this2$state$allFilte.name.toLowerCase();
          });
          var itemContentTypes = item.contentTypes.map(function (el) {
            return el.toLowerCase();
          });
          return item.name.toLowerCase().includes(query.toLowerCase()) || item.text.toLowerCase().includes(query.toLowerCase()) || itemContentTypes.findIndex(function (v) {
            return v === null || v === void 0 ? void 0 : v.includes(query.toLowerCase());
          }) > -1 || itemFiltersNames.findIndex(function (v) {
            return v === null || v === void 0 ? void 0 : v.includes(query.toLowerCase());
          }) > -1;
        });
        contentType.filteredItems = filteredContentType;
        return contentType.filteredItems.length > 0;
      });
      this.props.updateItemsByContentType(itemsContainingQuery);
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      var top = window.innerWidth > 767 ? 48 : 0;
      window.scrollTo({
        top: top,
        behavior: "smooth"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        title = _this$props.title,
        placeholder = _this$props.placeholder,
        popularQueriesTitle = _this$props.popularQueriesTitle,
        filters = _this$props.filters,
        contentTypes = _this$props.contentTypes,
        rawContentTypes = _this$props.rawContentTypes,
        onClearAll = _this$props.onClearAll,
        scrollToTopLabel = _this$props.scrollToTopLabel;
      var _this$state = this.state,
        searchQuery = _this$state.searchQuery,
        allFilters = _this$state.allFilters,
        pageScrollOffset = _this$state.pageScrollOffset,
        showSuggestions = _this$state.showSuggestions;
      return /*#__PURE__*/React.createElement("div", {
        className: "resource-center__search",
        id: "resource-center--search"
      }, /*#__PURE__*/React.createElement(SearchHeader, {
        title: title
      }), /*#__PURE__*/React.createElement("div", {
        className: "resource-center__search__main"
      }, !!allFilters.length && /*#__PURE__*/React.createElement("div", {
        className: "resource-center__search__container",
        ref: this.searchContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: "resource-center__search__field"
      }, /*#__PURE__*/React.createElement(SearchField, {
        placeholder: placeholder,
        searchQuery: searchQuery,
        updateSearchQuery: this.updateSearchQuery,
        handleSearch: this.search,
        onClearAll: onClearAll,
        searchInputRef: this.searchInput
      }), /*#__PURE__*/React.createElement(SearchFieldSuggestions, {
        filters: allFilters,
        contentTypes: rawContentTypes,
        searchQuery: searchQuery,
        handleSearch: this.search,
        searchInputRef: this.searchInput,
        showSuggestions: showSuggestions
      })), /*#__PURE__*/React.createElement(SearchPopularQueries, {
        title: popularQueriesTitle,
        filters: filters,
        handleSearch: this.search,
        searchQuery: searchQuery,
        searchInputRef: this.searchInput,
        pageScrollOffset: pageScrollOffset
      })), /*#__PURE__*/React.createElement(SearchListNavigation, {
        contentTypes: contentTypes,
        pageScrollOffset: pageScrollOffset
      })), /*#__PURE__*/React.createElement(SearchScrollToTop, {
        label: scrollToTopLabel,
        searchContainer: this.searchContainer,
        pageScrollOffset: pageScrollOffset,
        scrollToTop: this.scrollToTop
      }));
    }
  }]);
}(React.Component);
export default Search;